import React, { useState } from 'react';
import './App.css';
import Onboarding from './components/Onboarding';
import HomePage from './components/HomePage';
import ChatPage from './components/ChatPage';
import RecipeDetail from './components/RecipeDetail';

// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("React hatası yakalandı:", error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Bir şeyler yanlış gitti</h2>
          <details style={{ whiteSpace: 'pre-wrap', margin: '10px', padding: '10px', border: '1px solid #ddd' }}>
            <summary>Hata Detayları</summary>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
          <button onClick={() => window.location.reload()}>
            Sayfayı Yenile
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

function App() {
  const [showOnboarding, setShowOnboarding] = useState(true);
  const [userData, setUserData] = useState(null);
  const [currentPage, setCurrentPage] = useState('home');
  const [selectedRecipe, setSelectedRecipe] = useState(null);
  const [userProfile, setUserProfile] = useState({
    gender: null,
    ageRange: null,
    cookingLevel: null,
    cuisinePreferences: [],
  });

  const handleOnboardingComplete = (data) => {
    setUserData(data);
    setShowOnboarding(false);
  };

  // Navigate to different pages
  const navigateTo = (page) => {
    setCurrentPage(page);
  };

  // Handle recipe selection
  const handleRecipeSelect = (recipe) => {
    setSelectedRecipe(recipe);
    setCurrentPage('recipe-detail');
  };

  // Handle back from recipe detail
  const handleBackFromRecipe = () => {
    setSelectedRecipe(null);
    setCurrentPage('home');
  };

  // Render the current page based on navigation state
  const renderCurrentPage = () => {
    switch(currentPage) {
      case 'home':
        return <HomePage 
          userProfile={userProfile} 
          navigateTo={navigateTo} 
          onRecipeSelect={handleRecipeSelect}
        />;
      case 'chat':
        return <ChatPage navigateTo={navigateTo} />;
      case 'recipe-detail':
        return <RecipeDetail 
          recipe={selectedRecipe} 
          onBack={handleBackFromRecipe} 
        />;
      default:
        return <HomePage 
          userProfile={userProfile} 
          navigateTo={navigateTo} 
          onRecipeSelect={handleRecipeSelect}
        />;
    }
  };

  return (
    <ErrorBoundary>
      <div className="mobile-app-container">
        {showOnboarding ? (
          <Onboarding onComplete={handleOnboardingComplete} />
        ) : (
          renderCurrentPage()
        )}
      </div>
    </ErrorBoundary>
  );
}

export default App;
